import { ComponentsVariants } from '@mui/material/styles/variants';

export const MUI_TYPOGRAPHY_VARIANTS_OVERRIDES: ComponentsVariants['MuiTypography'] = [
  {
    props: { variant: 'h3' },
    style: ({ theme }) => ({
      fontSize: theme.spacing(2.25),
      fontWeight: 500,
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
    }),
  },
  {
    props: { variant: 'h5' },
    style: ({ theme }) => ({
      fontSize: theme.spacing(2),
      fontWeight: 700,
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
    }),
  },
];
